import { Button } from '@mui/material';

import HeadsetCustomerSupportIcon from 'modules/common/components/Icons/HeadsetCustomerSupportIcon';

interface NotScheduledViewProps {
    onSchedule: () => void;
}

export default function NotScheduledView({ onSchedule }: NotScheduledViewProps) {
    return (
        <Button
            onClick={onSchedule}
            size="large"
            variant="text"
            sx={{ mb: 3 }}
            startIcon={<HeadsetCustomerSupportIcon />}
            fullWidth>
            Schedule a call with us
        </Button>
    );
}
